import { useState, useEffect } from 'react';
import Header from '../../components/layout/Header';
import Body from '../../components/layout/Body';
import Table from '../../components/layout/Table';
import { Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useURLParams } from '../../contexts/ParamsContext';
import { useNotice } from '../../contexts/NoticeContext';

import {
    fetchOptionPages,
    deleteOptionPage,
} from '../../utils/api';

const OptionPageList = () => {
    const { updateUrlParams } = useURLParams();
    const { showNotice } = useNotice();
    const [optionPages, setOptionPages] = useState([]);

    useEffect(() => {
        fetchOptionPages()
            .then(setOptionPages)
            .catch((error) => {
                showNotice(
                    error?.message || __('Something went wrong while fetching option pages.', 'voxycure-framework'),
                    'error'
                );
            });
    }, []);

    const handleDeleteOptionPage = (id) => {
        if (!confirm(__('Are you sure you want to delete this options page?', 'voxycure-framework'))) return;

        deleteOptionPage(id)
            .then(() => {
                setOptionPages((prev) => prev.filter((page) => page.id !== id));
                showNotice(__('Options page deleted successfully.', 'voxycure-framework'), 'success');
            })
            .catch((error) => {
                showNotice(
                    error?.message || __('Something went wrong while deleting options page.', 'voxycure-framework'),
                    'error'
                );
            });
    };

    return (
        <>
            <Header>
                <h2 className="voxycure-editor__header-title">
                    {__('All Options Pages', 'voxycure-framework')}
                </h2>
                <Button
                    className="components-button is-primary voxycure-button"
                    onClick={() => updateUrlParams({ view: 'new-options-page' })}
                >
                    {__('Add New Options Page', 'voxycure-framework')}
                </Button>
            </Header>

            <Body>
                <Table
                    columns={[
                        { key: 'title', label: __('Title', 'voxycure-framework') },
                        { key: 'status', label: __('Status', 'voxycure-framework') },
                        { key: 'actions', label: __('Actions', 'voxycure-framework') },
                    ]}
                    data={optionPages}
                    emptyMessage={__('No options pages found. Please try to create a new one.', 'voxycure-framework')}
                    renderRow={(page) => (
                        <tr key={page.id} style={{ borderBottom: '1px solid #eee' }}>
                            <td style={{ padding: '0.75rem' }}>{page.name || '-'}</td>
                            <td style={{ padding: '0.75rem' }}>{page.status ?? '-'}</td>
                            <td style={{ padding: '0.75rem' }}>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <Button
                                        isSmall
                                        isSecondary
                                        onClick={() => updateUrlParams({ view: 'edit-options-page', id: page.id })}
                                    >
                                        {__('Edit', 'voxycure-framework')}
                                    </Button>
                                    <Button
                                        isSmall
                                        isDestructive
                                        onClick={() => handleDeleteOptionPage(page.id)}
                                    >
                                        {__('Delete', 'voxycure-framework')}
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    )}
                />
            </Body>
        </>
    );
};

export default OptionPageList;
